import { a as addDays, l as leadingZero, p as parseDate, g as getCurrentDate, S as SHORT_MONTHS, L as LONG_MONTHS, f as formatDate, D as DEFAULT_DATE_FORMAT } from './dateHelpers-cf959379.js';
import { getMonth, getDate, getYear } from 'date-fns';
import { isNilOrEmpty } from './stringUtils.js';
import 'ramda';

const tryParseDayOfWeek = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parseForPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const matchedToDayOfWeek = dateStr.match(
  // eslint-disable-next-line max-len
  /^(monday|mon|mo|tuesday|tues|tue|tu|wednesday|weds|wed|we|thursday|thur|thurs|thu|th|friday|fri|fr|saturday|sat|sa|sunday|sun|su|tomorrow|yesterday)$/i);
  if (isNilOrEmpty(matchedToDayOfWeek)) {
    return '';
  }
  let now = getCurrentDate();
  let dayIndex = 0;
  switch (dateStr.toLowerCase()) {
    case 'sunday':
    case 'sun':
    case 'su':
      dayIndex = 0;
      break;
    case 'monday':
    case 'mon':
    case 'mo':
      dayIndex = 1;
      break;
    case 'tuesday':
    case 'tues':
    case 'tue':
    case 'tu':
      dayIndex = 2;
      break;
    case 'wednesday':
    case 'weds':
    case 'wed':
    case 'we':
      dayIndex = 3;
      break;
    case 'thursday':
    case 'thurs':
    case 'thur':
    case 'thu':
    case 'th':
      dayIndex = 4;
      break;
    case 'friday':
    case 'fri':
    case 'fr':
      dayIndex = 5;
      break;
    case 'saturday':
    case 'sat':
    case 'sa':
      dayIndex = 6;
      break;
    case 'tomorrow':
      dayIndex = parseForPast ? now.getDay() : now.getDay() + 1;
      break;
    case 'yesterday':
      dayIndex = parseForPast ? now.getDay() - 1 : now.getDay();
      break;
  }
  if (parseForPast) {
    now = addDays(now, dayIndex < now.getDay() ? dayIndex - now.getDay() : -1 * (7 - dayIndex + now.getDay()));
  } else {
    now = addDays(now, dayIndex > now.getDay() ? dayIndex - now.getDay() : 7 - now.getDay() + dayIndex);
  }
  const month = leadingZero(getMonth(now) + 1);
  const day = leadingZero(getDate(now));
  return parseDate(`${getYear(now)}-${month}-${day}`);
};

const tryParseNumericalDefaultFormatDate = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // match against a number string ex. 11/21/1987 OR 11/21/87
  const matchedToNumericalDefaultDateFormat = dateStr.match(/^(\d{4})?[/\-.\s,]?([0-3]?[0-9]{1})[/\-.\s,]?([0-1]??[0-9]{1,2})$/);
  if (isNilOrEmpty(matchedToNumericalDefaultDateFormat)) {
    return '';
  }
  return parseDate(dateStr);
};

const tryParseNumericalDate = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parseForPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // match against a number string ex. 11/21/1987 OR 11/21/87
  const matchedToNumericalDate = dateStr.match(/^(\d+)[/\-.\s,](\d+)[/\-.\s,]?(\d+)?$/);
  if (isNilOrEmpty(matchedToNumericalDate)) {
    return '';
  }
  let [, month, day, year] = matchedToNumericalDate;
  month = Number(month);
  day = Number(day);
  if (month > 12 || month === 0) return '';
  if (day > 31 || day === 0) return '';
  const currentDate = getCurrentDate();
  const currentDateYear = getYear(currentDate);
  if (year && year.length === 1) year = Number(`200${year}`);else if (year && year.length === 2) year = Number(`20${year}`);else if (year && year.length === 4) year = Number(year);
  if (!year) {
    if (parseForPast) {
      year = new Date(currentDateYear, month - 1, day) > currentDate ? currentDateYear - 1 : currentDateYear;
    } else {
      year = new Date(currentDateYear, month - 1, day) < currentDate ? currentDateYear + 1 : currentDateYear;
    }
  } else {
    const selectedDate = new Date(year, month - 1, day);
    if (parseForPast && selectedDate > currentDate) return '';
    if (!parseForPast && selectedDate > currentDate) return '';
  }
  return parseDate(`${year}-${leadingZero(month)}-${leadingZero(day)}`);
};

const tryParseNumericalDateThenMonth = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parseForPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // match against date followed by the month
  const matchedToNumericalDateThenMonth = dateStr.match(
  // eslint-disable-next-line max-len
  /^(\d+)[\/\-\.\s,](january|jan|february|feb|march|mar|april|apr|may|june|jun|july|jul|august|aug|september|sep|october|oct|november|nov|december|dec)([\/\-\.\s,]+)?(\d+)?$/i);
  if (isNilOrEmpty(matchedToNumericalDateThenMonth)) {
    return '';
  }
  let [, day, month,,, year] = matchedToNumericalDateThenMonth;
  month = month.toLowerCase();
  let monthIdx = SHORT_MONTHS.indexOf(month);
  if (monthIdx === -1) {
    monthIdx = LONG_MONTHS.indexOf(month);
  }
  month = monthIdx + 1;
  day = Number(day);
  if (month > 12 || month === 0) return '';
  if (day > 31 || day === 0) return '';
  const currentDate = getCurrentDate();
  const currentDateYear = getYear(currentDate);
  if (year && year.length === 1) year = Number(`200${year}`);else if (year && year.length === 2) year = Number(`20${year}`);else if (year && year.length === 4) year = Number(year);
  if (!year) {
    if (parseForPast) {
      year = new Date(currentDateYear, month - 1, day) > currentDate ? currentDateYear - 1 : currentDateYear;
    } else {
      year = new Date(currentDateYear, month - 1, day) < currentDate ? currentDateYear + 1 : currentDateYear;
    }
  } else {
    const selectedDate = new Date(year, month - 1, day);
    if (parseForPast && selectedDate > currentDate) return '';
    if (!parseForPast && selectedDate > currentDate) return '';
  }
  return parseDate(`${year}-${leadingZero(month)}-${leadingZero(day)}`);
};

const tryParseMonthThenNumericalDate = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parseForPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // match against the month followed by date
  const matchedToMonthThenNumericalDate = dateStr.match(
  // eslint-disable-next-line max-len
  /^(january|jan|february|feb|march|mar|april|apr|may|june|jun|july|jul|august|aug|september|sep|october|oct|november|nov|december|dec)[\/\-\.\s,]+(\d+)([\/\-\.\s,]+)?(\d+)?$/i);
  if (isNilOrEmpty(matchedToMonthThenNumericalDate)) {
    return '';
  }
  let [, month, day,, year] = matchedToMonthThenNumericalDate;
  month = month.toLowerCase();
  let monthIdx = SHORT_MONTHS.indexOf(month);
  if (monthIdx === -1) {
    monthIdx = LONG_MONTHS.indexOf(month);
  }
  month = monthIdx + 1;
  day = Number(day);
  if (month > 12 || month === 0) return '';
  if (day > 31 || day === 0) return '';
  const currentDate = getCurrentDate();
  const currentDateYear = getYear(currentDate);
  if (year && year.length === 1) year = Number(`200${year}`);else if (year && year.length === 2) year = Number(`20${year}`);else if (year && year.length === 4) year = Number(year);
  if (!year) {
    if (parseForPast) {
      year = new Date(currentDateYear, month - 1, day) > currentDate ? currentDateYear - 1 : currentDateYear;
    } else {
      year = new Date(currentDateYear, month - 1, day) < currentDate ? currentDateYear + 1 : currentDateYear;
    }
  } else {
    const selectedDate = new Date(year, month - 1, day);
    if (parseForPast && selectedDate > currentDate) return '';
    if (!parseForPast && selectedDate > currentDate) return '';
  }
  return parseDate(`${year}-${leadingZero(month)}-${leadingZero(day)}`);
};

const tryParseISODate = function () {
  let dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let parseForPast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // This matches standard ISO datestrings with no milliseconds or timezone
  const matchedISO = dateString.match(/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/i);
  if (isNilOrEmpty(matchedISO)) {
    return '';
  }
  const currentDate = getCurrentDate();
  const selectedDate = parseDate(dateString);
  if (parseForPast && selectedDate > currentDate) {
    return '';
  }
  return selectedDate;
};

const tryParseDate = function () {
  let dateStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let outputFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  let parseForPast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let parsedDate = new Date();
  let res = {
    isParsed: false,
    formattedDate: formatDate(parsedDate, outputFormat),
    parseType: 'default'
  };
  parsedDate = tryParseISODate(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseISOFormatDate'
    };
  }

  // match against a number string ex. 11/21/1987 OR 11/21/87
  parsedDate = tryParseNumericalDefaultFormatDate(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseNumericalDefaultFormatDate'
    };
  }

  // match against a number string ex. 11/21/1987 OR 11/21/87
  parsedDate = tryParseNumericalDate(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseNumericalDate'
    };
  }

  // match against date followed by the month
  parsedDate = tryParseNumericalDateThenMonth(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseNumericalDateThenMonth'
    };
  }

  // match against the month followed by date
  parsedDate = tryParseMonthThenNumericalDate(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseMonthThenNumericalDate'
    };
  }

  // match against the day of the week
  parsedDate = tryParseDayOfWeek(dateStr, parseForPast);
  if (!isNilOrEmpty(parsedDate)) {
    res = {
      isParsed: true,
      formattedDate: formatDate(parsedDate, outputFormat),
      parseType: 'tryParseDayOfWeek'
    };
  }
  return res;
};

export { tryParseDate };
//# sourceMappingURL=tryParseDate.js.map
